import UserConfirmation from './UserConfirmation';

export default UserConfirmation;
